import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const imageImporterSelectors = importerSelectors(
  'image.importer',
);

export default imageImporterSelectors;
